import { reduxEqualityFunction } from 'library/helpers/utility';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentProfileOrgSettings } from 'reduxStore/settings/selectors';

/**
 * Custom hook to determine if a module setting is enabled or disabled.
 *
 * @param {number} settingID - The ID of the setting to check.
 * @returns {boolean} - Returns true if the module setting is enabled, otherwise false.
 */
const useModuleSettings = (settingID) => {
	// Get the Current Settings from redux
	const currentSelectedSettings = useSelector(selectCurrentProfileOrgSettings, {
		equalityFn: reduxEqualityFunction
	});

	// Local State to store the enabled/disabled state of the module
	const [enabledAccessModule, setEnabledAccessModule] = useState(false);

	// Check if the setting is enabled or disabled
	useEffect(() => {
		const accessControlSetting =
			currentSelectedSettings?.find((setting) => setting.defaultSettingID === settingID)?.value === 1;

		setEnabledAccessModule(accessControlSetting);
	}, [settingID, currentSelectedSettings]);

	return enabledAccessModule;
};

export default useModuleSettings;
